import { render, staticRenderFns } from "./NewMeasure.vue?vue&type=template&id=fd2a820e&scoped=true&"
import script from "./NewMeasure.vue?vue&type=script&lang=js&"
export * from "./NewMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2a820e",
  null
  
)

export default component.exports